import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const API_SERVICE_URL = process.env.REACT_APP_SERVICE_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/TokenAuth/VerifyToken`
export const LOGIN_URL = `${API_URL}/TokenAuth/Authenticate`
export const REGISTER_URL = `${API_SERVICE_URL}/Account/register`
export const VERIFY_EMAIL_URL = `${API_SERVICE_URL}/Account/Validate`
export const TWO_WAY_AUTH_URL = `${API_URL}/TokenAuth/TwoWayAuth`
export const TWO_WAY_AUTH_REFRESH_URL = `${API_URL}/TokenAuth/TwoWayAuthRefresh`
export const RESET_PASSWORD_URL = `${API_SERVICE_URL}/Account/ResetPassword`
export const REQUEST_PASSWORD_URL = `${API_SERVICE_URL}/Account/ForgotPassword`

// Server should return AuthModel
export function login(userNameOrEmailAddress: string, password: string, recaptcha: string,lang : string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    userNameOrEmailAddress,
    password,
    recaptcha,
    lang
  })
}

// Server should return AuthModel
export function register(
  emailAddress: string,
  name: string,
  surname: string,
  password: string,
  fatherName:string,
  tc:string,
  birthDate:string,
  graduateDate : string,
  lang: string 
) {
  return axios.post(REGISTER_URL, {
    emailAddress: emailAddress,
    name: name,
    surname: surname,
    password: password,
    fatherName: fatherName,
    tc: tc,
    birthDate: birthDate,
    graduateDate : graduateDate,
    lang : lang
  })
}

// Server should return AuthModel
export function verifyEmail(
  emailConfirmationCode: string
) {
  return axios.post(VERIFY_EMAIL_URL, {
    code : emailConfirmationCode,
  })
}

// Server should return AuthModel
export function twoWayAuthConfirmation(
  userNameOrEmailAddress : string,
  password : string,
  code: string,
  lang : string
) {
  return axios.post(TWO_WAY_AUTH_URL, {
    userNameOrEmailAddress : userNameOrEmailAddress,
    password : password,
    code : code,
    lang: lang
  })
}

// Server should return AuthModel
export function twoWayAuthResend(
  userNameOrEmailAddress : string,
  password : string,
  lang : string
) {
  return axios.post(TWO_WAY_AUTH_REFRESH_URL, {
    userNameOrEmailAddress : userNameOrEmailAddress,
    password : password,
    lang: lang
  })
}

// Server should return AuthModel
export function passwordReset(
  eMailAddress : string,
  emailConfirmationCode: string,
  password: string
) {
  return axios.post(RESET_PASSWORD_URL, {
    code : emailConfirmationCode,
    eMail :eMailAddress,
    password : password
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    eMail : email,
  })
}

export function getUserByToken() {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL)
}
